import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AnwenderbetriebService } from '@service/anwenderbetrieb.service';
import { Anwenderbetrieb } from '@entity/anwenderbetrieb';

export const AnwenderbetriebeResolve: ResolveFn<Anwenderbetrieb[]> = () => {
  return inject(AnwenderbetriebService).getAllAnwenderbetriebe(true);
};
